export const socialShare = (from) => {
  const fbShare = document.querySelectorAll('.social_share_component .share-fb')
  const twitterShare = document.querySelectorAll('.social_share_component .share-twitter')
  const linkedInShare = document.querySelectorAll('.social_share_component .share-linkedin')

  if (fbShare?.length) {
    fbShare.forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault()
        const winTop = screen.height / 2 - window.innerHeight / 2
        const winLeft = screen.width / 2 - window.innerWidth / 2
        const article = getArticledata(elt)

        window.open(
          'https://www.facebook.com/sharer.php?u=' + encodeURIComponent(article.articleUrl),
          'sharer',
          'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + window.innerWidth / 2 + ',height=' + window.innerHeight / 2
        )
        return false
      })
    })
  }

  if (twitterShare?.length) {
    twitterShare.forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault()
        const article = getArticledata(elt)
        window.open(
          'https://twitter.com/share?url=' + encodeURIComponent(article.articleUrl) + '&text=' + article.title,
          'twitter',
          'height=500, width=700, toolbar=no, menubar=no, scrollbars=no, resizable=no, location=no, directories=no, status=no'
        )
        return false
      })
    })
  }

  if (linkedInShare?.length) {
    linkedInShare.forEach((elt) => {
      elt.addEventListener('click', (e) => {
        e.preventDefault()
        const article = getArticledata(elt)
        window.open(
          'https://www.linkedin.com/shareArticle?mini=true&url=' + encodeURIComponent(article.articleUrl) + '+&title=' + article.title + '&summary=&source=LinkedIn',
          'LinkedIn',
          'height=285,width=550,resizable=1'
        )
        return false
      })
    })
  }

  const getArticledata = (elt) => {
    // const linkedArticle = elt.closest('.social_share_component')?.nextElementSibling?.querySelector('.title a')
    // const urlShare = linkedArticle?.getAttribute('href')
    // const title = linkedArticle.innerText ? linkedArticle.innerText : ''*
    const dataElt = elt.closest('.social_share_component')
    const title = dataElt.dataset.title
    const link = dataElt.dataset.article ? dataElt.dataset.article : ''
    // const completeUrl = urlShare ? window.location.origin + urlShare : window.location.href // ajouter le langcode !
    const completeUrl = link ? window.location.origin + link : window.location.href // ajouter le langcode !
    return { articleUrl: completeUrl, title: title }
  }
}
